import React from "react";
import { Admin, Resource } from "react-admin";
import trucknetRestClient from "./trucknetRestClient";
import authProvider from "./authProvider";

import Dashboard from "./dashboard/Dashboard";
// users
import UserList from "./users/List";
import UserEdit from "./users/Edit";
// companies
import CompanyList from "./companies/List";
import CompanyEdit from "./companies/Edit";
import CompanyShow from "./companies/Show";
// companies
import MatchesList from "./matches/List";
// representatives
import RepresentativesList from "./representatives/List";
// requests
import RidesList from "./rides/RidesList";

import users from "./images/users.svg";
import match from "./images/match.svg";
import user from "./images/user.svg";
import company from "./images/company.svg";
import truck from "./images/truck.svg";
import cargo from "./images/cargo.svg";
import shadow from "./images/shadow.svg";
import CustomIcon from "./components/CustomIcon";

const userResourceOptions = {
  label: "Users",
};

const companyResourceOptions = {
  label: "Companies",
};

const matchesResourceOptions = {
  label: "Matches",
};

const representativesResourceOptions = {
  label: "Representatives",
};

const App = () => (
  <Admin
    title="Trucknet"
    authProvider={authProvider}
    dataProvider={trucknetRestClient}
    dashboard={Dashboard}
    loginPage={null}>
    <Resource
      name="admin/users"
      list={UserList}
      edit={UserEdit}
      options={userResourceOptions}
      icon={() => <CustomIcon src={users} />}
    />
    <Resource
      name="admin/companies"
      list={CompanyList}
      options={companyResourceOptions}
      edit={CompanyEdit}
      show={CompanyShow}
      icon={() => <CustomIcon src={company} />}
    />
    <Resource
      name="admin/matches"
      list={MatchesList}
      options={matchesResourceOptions}
      icon={() => <CustomIcon src={match} />}
    />
    <Resource
      name="admin/representatives-statistics"
      list={RepresentativesList}
      options={representativesResourceOptions}
      icon={() => <CustomIcon src={user} />}
    />
    <Resource
      name="admin/requests"
      list={RidesList}
      options={{ label: "Requests" }}
      icon={() => <CustomIcon src={cargo} />}
    />
    <Resource
      name="admin/shadows"
      list={RidesList}
      options={{ label: "Empty rides" }}
      icon={() => <CustomIcon src={shadow} />}
    />
    <Resource
      name="admin/commutes"
      list={RidesList}
      options={{ label: "Commutes" }}
      icon={() => <CustomIcon src={truck} />}
    />
  </Admin>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js